import { Money } from '@nemuru-eng/js-api-client';
import { getLoanCalculatorsByPricings, LoanCalculator, PricingFromCdn } from '@nemuru-eng/js-api-client/slim';

import { ChangeLoanConditions } from '@/components/widgets/LoanDetailActions/components/LoanDetailActionsDialog/components/ChangeLoanConditionsDialog/services/ChangeLoanConditions';

export class LoanConditionsCalculator {
  private static instance: LoanConditionsCalculator | null = null;
  private selectedTerm?: number;
  private selectedPrincipal?: number;
  private selectedPricing?: PricingFromCdn;
  private loanCalculators: LoanCalculator[] = [];

  private constructor() {}

  public static getInstance(): LoanConditionsCalculator {
    if (!LoanConditionsCalculator.instance) {
      LoanConditionsCalculator.instance = new LoanConditionsCalculator();
    }
    return LoanConditionsCalculator.instance;
  }

  private async updateLoanCalculators(term: number, principal: Money, pricing: PricingFromCdn): Promise<void> {
    if (!ChangeLoanConditions.isTermWithinRange(pricing, term)) {
      return;
    }

    try {
      this.loanCalculators = getLoanCalculatorsByPricings({
        pricings: [pricing],
        principal,
        terms: [term],
      });
    } catch (error) {
      console.error('Error fetching loan calculators:', error);
      this.loanCalculators = [];
    }
  }

  public async setLoanConditions(term: number, principal: Money, pricing: PricingFromCdn): Promise<void> {
    if (term !== this.selectedTerm || principal.value !== this.selectedPrincipal || pricing !== this.selectedPricing) {
      this.selectedTerm = term;
      this.selectedPrincipal = principal.value;
      this.selectedPricing = pricing;
      await this.updateLoanCalculators(term, principal, pricing);
    }
  }

  public getLoanCalculator(): LoanCalculator {
    return this.loanCalculators[0];
  }

  public deleteLoanCalculator(): void {
    this.loanCalculators = [];
  }
}
